module.exports = {
    individualData: () => {
        return[
            {
                "FAMILIAS":[
                    /*{
                        "Nombre":"SUPER METRO ACCENT"
                    },
                    {
                        "Nombre":"GRAND METRO HB"
                    },
                    {
                        "Nombre":"GRAND METRO SEDAN"
                    },*/
                    {
                        "Nombre":"GRAND METRO TAXI"
                    },
                    /*{
                        "Nombre":"HD78"
                    },
                    {
                        "Nombre":"HD65"
                    },
                    {
                        "Nombre":"HD55"
                    },*/
                    {
                        "Nombre":"EX8"
                    },
                    {
                        "Nombre":"EX10"
                    },
                    {
                        "Nombre":"STARIA"
                    }
                ]
            }
        ]
    }
}